<template>
  <div>
    <el-header ref="header" class="header" style="height: auto;margin-bottom: 10px">
      <el-form  :inline="true" :model="searchForm" ref="searchFormRef" class="demo-form-inline">
        <el-form-item label="" prop="company" >
          <el-input placeholder="请输入公司名称" v-model="searchForm.company"  @keydown.enter.native="handleSearchBtn"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="handleSearchBtn" icon="el-icon-search">搜索</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-table
      border
      :data="data"
      highlight-current-row
      class="bearing-table"
      :max-height="500"
      @row-click="handleRowClick"
    >
      <el-table-column prop="cid" label="CID" />
      <el-table-column prop="classname" label="客户类别" />
      <el-table-column prop="company" label="公司名称" />
    </el-table>
    <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                   :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]"
                   :page-size="selectPage.pageSize"
                   background
                   layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                   style="margin-top: 14px;margin-bottom:14px"
    >
    </el-pagination>
  </div>
</template>
<script>
import { defineComponent, reactive, ref,onMounted } from '@vue/composition-api'
import QuotationCompany from './quotationCompany.vue'
import request from '@/utils/request'
export default defineComponent({
  components: { QuotationCompany},
  setup(props,{emit}) {
    const data = ref([])
    const selectedCompany = ref('')
    const searchFormRef = ref(null)
    const searchForm = reactive({
      company: '',
    })
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20
    })
    const allNum = ref(1)

    // 选择联系人
    const handleRowClick = (row) => {
      selectedCompany.value = `${row.company}`
      emit('selectedCompany',row)
    }


    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getCompany()
    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getCompany()
    }

    const handleSearchBtn = () => {
      getCompany()
    }

    const getCompany = () => {
      request({
        url: 'quotation_company.yy',
        method: 'post',
        params: selectPage,
        data: searchForm
      }).then(res => {
        if (res.code == 200) {
          data.value = res.listrow
          allNum.value = res.total
        }
      })
    }

    onMounted(()=>{
      getCompany()
    })
    return{
      data,
      selectedCompany,
      selectPage,
      allNum,
      searchFormRef,
      searchForm,
      handleRowClick,
      pageSizeChange,
      pageCurrentChange,
      handleSearchBtn
    }
  }
})
</script>
<style lang="scss" scoped>
.bearing-table {
  margin: 0 10px;
}
.el-header {
  padding: 0;
}
</style>
